/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';
import ReactReadMoreReadLess from 'react-read-more-read-less';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Testimonials.scss';
import testimonials, { brands } from './FakeData';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex">
            <img
              src={testimonials[currentIndex].imgurl}
              alt={testimonials[currentIndex].name}
            />
            <div className="app__testimonial-content">
              <p className="p-text">
                <ReactReadMoreReadLess
                  charLimit={200}
                  readMoreText="see more ▼"
                  readLessText="see less ▲"
                >
                  {testimonials[currentIndex].feedback}
                </ReactReadMoreReadLess>
              </p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div
              className="app__flex"
              onClick={() => handleClick(
                currentIndex === 0
                  ? testimonials.length - 1
                  : currentIndex - 1,
              )}
            >
              <HiChevronLeft />
            </div>

            <div
              className="app__flex"
              onClick={() => handleClick(
                currentIndex === testimonials.length - 1
                  ? 0
                  : currentIndex + 1,
              )}
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand.id}
          >
            <img src={brand.imgUrl} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonials',
  'app__primarybg',
);
